import React from 'react';

import Home from '../components/Home';

const Login = () => {
  return <Home />;
};

export default Login;
